<template>
  <div class="svg-body" ref="svgSeats">
    <div v-if="loading" class="loader-svg">
      <Loader></Loader>
    </div>
    <div id="svgEmbed"></div>
  </div>
</template>
<script>
import $ from 'jquery';
import svgPanZoom from '../utils/svg-pan-zoom';

const stopWheel = (e) => {
  e.preventDefault();
};

export default {
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    svgHtml: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      mutableVal: this.value,
      seatSelector: null,
    };
  },
  mounted() {
    const elem = this.$refs.svgSeats;
    if (elem.addEventListener) {
      elem.addEventListener('mousewheel', stopWheel, false);
      elem.addEventListener('DOMMouseScroll', stopWheel, false);
    } else if (elem.attachEvent) {
      elem.attachEvent('onmousewheel', stopWheel);
    }
  },
  methods: {
    getSvg(cb) {
      this.loading = true;
      $.get(
        this.svgHtml,
        { Origin: 'jn-v2' },
        (svg) => {
          $('#svgEmbed').html(svg);
          this.loading = false;
          cb();
        },
        'text',
      );
    },
    init(cb) {
      this.getSvg(() => {
        this.seatSelector = $('.svg-seat');
        this.disableAllSeats();
        svgPanZoom('#svgZoom');
        this.clickSeat();
        cb();
      });
    },
    clickSeat() {
      this.seatSelector.unbind('click');
      this.seatSelector.on('click', (event) => {
        const {
          id,
          dataset: { disabled, toggle },
        } = event.currentTarget;
        if (disabled) return;
        if (!toggle) {
          this.$emit('on-verify-seat', { id });
        } else {
          this.updateSeat(id);
        }
      });
    },
    updateSeat(id) {
      const seat = Object.assign(this.mutableVal[id]);
      this.$delete(this.mutableVal, id);
      $(`#${id}`).removeAttr('data-toggle');
      // this.$emit('on-verify-seat', this.mutableVal[id], true);
      this.$emit('update-seat', { isRemove: true, type: seat.type, id });
      this.$emit('input', this.mutableVal);
    },
    setSeatVerify(available, { type, id }) {
      // available: 0, 1 | false, true
      if (available) {
        this.$set(this.mutableVal, id, { type, id });
        $(`#${id}`).attr('data-toggle', true).removeAttr('data-disabled');
        this.$emit('update-seat', { isRemove: false, type, id });
      } else {
        this.disableSeats([id]);
        // eslint-disable-next-line
        alert('Este asiento ya no está disponible!');
      }
      this.$emit('input', this.mutableVal);
    },
    disableAllSeats() {
      this.seatSelector.attr('data-disabled', true).removeAttr('data-toggle');
      // this.mutableVal = {}
      // this.$emit('input', this.mutableVal)
    },
    enableSeats(seatsArr) {
      seatsArr.forEach((item) => {
        const seatId = item.id.toUpperCase();
        $(`#${seatId}`)
          .removeAttr('data-disabled')
          .removeAttr('data-toggle');
      });
    },
    disableSeats(seatsArr) {
      seatsArr.forEach((id) => {
        const seat = id.toUpperCase();
        $(`#${seat}`).attr('data-disabled', true);
      });
    },
    selectToggleSeats(seatsArr) {
      seatsArr.forEach((item) => {
        this.setSeatVerify(true, item);
      });
    },
  },
};
</script>

<style lang="scss">
.loader-svg{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(#fff, 0.5);
}

.svg-body {
  height: 65vh;
  padding: 3px;
  background: #fff;
  // border: 1px solid #ddd;
  box-shadow: inset 0 3px 5px rgba(#000, 0.1);
  position: relative;
  svg{
    width: 100%;
    height: 64vh;
  }
}
.svg-seat {
  cursor: pointer;
}
.svg-seat[data-disabled] {
  cursor: default;
}
.svg-seat[data-disabled] > path,
.svg-seat[data-disabled] > rect {
  fill: #bbb;
}
.svg-seat[data-toggle]{
  > path,
  > rect{
    fill: #f95353;
  }
  text{
    fill: #fff;
  }
}
</style>
